module.exports = __webpack_public_path__ + "img/ico_badge03.eab655ec.svg";